import { helpers, required } from 'vuelidate/lib/validators'

/**
 * Model "class" for Message - defines useful field metadata for building and validating forms
 */

export default {
    fields: {
        name: {
            label: 'FIELD_MESSAGE_NAME',
            type: 'text',
        },
        subject: {
            label: 'FIELD_MESSAGE_SUBJECT',
            type: 'text',
        },
        body: {
            label: 'FIELD_MESSAGE_BODY',
            type: 'textarea',
        },
    }
}
